module.exports = "https://coursera_assets.s3.amazonaws.com/images/426cb040a85b211c32ed50aa5c0e7b88.jpg";